import { Component, EventEmitter, Input, Output } from '@angular/core';
import { HomeActionColumn, HomeActionItem } from '../models/home.models';

@Component({
  standalone: false,
  selector: 'app-home-operations-panel',
  templateUrl: './home-operations-panel.component.html',
  styleUrls: ['./home-operations-panel.component.scss'],
})
export class HomeOperationsPanelComponent {
  @Input({ required: true }) columns: HomeActionColumn[] = [];

  @Output() navigate = new EventEmitter<HomeActionItem>();

  onNavigate(item: HomeActionItem): void {
    this.navigate.emit(item);
  }

  trackColumn(_index: number, column: HomeActionColumn): string {
    return column.id;
  }

  trackSubsection(_index: number, subsection: { id: string }): string {
    return subsection.id;
  }
}
